module.exports = __webpack_public_path__ + "img/security_pic01.bb34bc32.jpg";